module.exports = __webpack_public_path__ + "img/tecnical-assistance.d244dd7e.svg";